import { createExchangeTokenRedirect } from '../../../admin-portal/src/services/exchangeTokenService.js'
import { TARGET_APPS } from '../../enums/target-apps.js'
import { showSnackbar } from '../../state/snackbar.js'
import { loadingSpinner } from '../../state/loading-spinner.js'
import { withNavMode, NAV_MODE_QUERY_PARAM, NAV_MODE_EMBEDDED } from './nav-mode.js'

export const DASHBOARD_NAVIGATION_TARGET_APP = TARGET_APPS.DASHBOARD
export const EXCHANGE_TOKEN_REDIRECT_ERROR_MESSAGE = 'Error authenticating portal access. Please try again later.'

// Re-export the entry-mode constants (AB#25457) so existing call sites can keep
// importing them from this module. Pure helpers live in ./nav-mode.js so they
// can be unit-tested without this module's Vue/HTTP dependencies.
export { NAV_MODE_QUERY_PARAM, NAV_MODE_EMBEDDED }

export async function getDashboardRedirectUrl (navMode) {
	const redirectUrl = await createExchangeTokenRedirect(TARGET_APPS.DASHBOARD)
	if (!redirectUrl) {
		console.error('[dashboard-navigation] exchange token redirect unavailable')
		showSnackbar({ text: EXCHANGE_TOKEN_REDIRECT_ERROR_MESSAGE, color: 'red' })
		return null
	}
	return withNavMode(redirectUrl, navMode)
}

export async function navigateToDashboardPortal (navMode) {
	const redirectUrl = await getDashboardRedirectUrl(navMode)
	if (!redirectUrl) {
		loadingSpinner.value = false
		return false
	}
	loadingSpinner.value = true
	window.location.href = redirectUrl
	return true
}
